<template>

  <v-container fluid style="height: 100%;" class="d-flex align-center justify-center flex-column">

      <div>
        <v-btn 
          color="primary"
          @click="loginFacebook()"
        >
          登入
        </v-btn>

      </div>


      <h5>Response:</h5>
      <div style="width:80%;">
        <v-textarea
          outlined
          v-model="response"
        >

        </v-textarea>
      </div>

  </v-container>

</template>

<script>
export default {
  name: 'FacebookLogin',
  data () {
    return {
      FB: null,
      response: null
    }
  },
  created: function(){
    console.log('created!')
    let that = this
    window.fbAsyncInit = function() {
      that.FB = window.FB
      that.FB.init({
          appId      : '1213707936310515',
          cookie     : true,
          xfbml      : true,
          version    : 'v20.0'
      });    
      that.getLoginStatus()
    };

    (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },
  mounted: async function(){
  },
  methods: {
    statusChangeCallback(response){
      console.log('response', response)
      this.response = JSON.stringify(response)
    },
    getLoginStatus(){
      let that = this
      this.FB.getLoginStatus(function(response) {
          that.statusChangeCallback(response);
      });
    },
    loginFacebook(){
      let that = this
      this.FB.login(
        function(response) {
          console.log(response);
          that.statusChangeCallback(response)
        },
        {
          config_id: '1199903024474559'
        }
      );
    }
  }

}


</script>